import { Query } from '@tanstack/react-query';

export function predicateFolder(query: Query, folderId: string) {
	const params = query.queryKey[1] as { folderId: string };
	return params.folderId === folderId;
}

export function predicateFolderIdList(query: Query, folderIds: string[]) {
	const params = query.queryKey[1] as { folderId: string };
	return folderIds.includes(params.folderId);
}
